import React, { ReactNode } from "react";
import { Link } from "@reach/router";
import styled from "@emotion/styled";
import { RailsUrl } from "@services";
import { useStoreAppValue } from "@hooks";
import { Box, Heading, TextUppercase, Flex } from "@atoms";

// == Types ================================================================

interface IProps {
  title?: string;
  collectionId: string;
  count?: number;
  onTitlePress?: () => void;
  forceCount?: boolean;
  url?: string;
  titleChildren?: ReactNode;
}

// == Constants ============================================================

CollectionTitle.defaultProps = {
  title: null,
  count: null,
  forceCount: false,
  url: null,
  titleChildren: null,
};

// == Component ============================================================

// == Component ============================================================

export default function CollectionTitle({
  count,
  title,
  collectionId,
  // onTitlePress,
  url,
  forceCount,
  titleChildren,
}: IProps) {
  const { campaignId } = useStoreAppValue();

  const collectionUrl = url ?? RailsUrl.collectionUrl({ id: collectionId, campaignId });

  const renderViewAllLink = () => {
    if ((count && count > 1) || forceCount) {
      return (
        <Link to={collectionUrl}>
          <Box>
            <TextUppercase fontSize={[0, 1]}>
              View All {count && count > 1 && `(${count})`}
            </TextUppercase>
          </Box>
        </Link>
      );
    }
    return false;
  };

  return (
    <Flex justifyContent="space-between" mb={2}>
      {!!title && (
        <EContainer>
          <ELink to={collectionUrl}>
            <Heading ellipsis display="inline-block" fontSize={[2, 3]}>
              {title}
            </Heading>
          </ELink>
          {titleChildren}
        </EContainer>
      )}
      {renderViewAllLink()}
    </Flex>
  );
}

// == Styles ===============================================================
const ELink = styled(Link)`
  vertical-align: middle;
`;
const EContainer = styled(Box)`
  width: 70%;
`;
